<div class="logos">
  <img alt="Bundesamt_für_Sicherheit_in_der_Informationstechnik-Logo"
       src="assets/Bundesamt_für_Sicherheit_in_der_Informationstechnik-Logo.svg">
  <img alt="Deutschland_Digita_Sicher_BSI" src="assets/Deutschland_Digita_Sicher_BSI.svg">
</div>
<div class="title-header">
  <div class="header-container">
    <h1>{{ headerText }}</h1>
  </div>
  <ng-content></ng-content>
</div>
